import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'urgentteam-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Urgent Team',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 615-988-2000,
  email: 'support@urgentteam.net',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/urgentteam/index.js